import { ComponentStyleConfig } from "@chakra-ui/react";

const DrawerComponentStyle: ComponentStyleConfig = {
  parts: ["dialog", "header", "body"],
  variants: {
    primary: {
      dialog: {
        background: "gray.100",
        boxShadow: "none",
        maxW: { base: "100%", lg: "50%", xl: "33.33%", "2xl": "25%" }
      }
    },
    secondary: {
      dialog: {
        background: "gray.200"
      }
    }
  }
};

export { DrawerComponentStyle };
